import './UsersTab.scss';

export { default } from './UsersTab';
